import type { OptionsDocument } from 'paintscout'
import type { EventTypeOption } from '..'

export function deleteEventType(args: { options: OptionsDocument; eventType: EventTypeOption }): OptionsDocument {
  const { options, eventType } = args
  const key = eventType.key

  const values = { ...(options.options.eventTypes?.values ?? {}) }
  if (values[key]) {
    values[key].deleted = true
  }
  return {
    ...options,
    options: {
      ...options.options,
      eventTypes: {
        ...options.options.eventTypes,
        values
      }
    }
  }
}

export function deleteEventTypes(args: { options: OptionsDocument; eventTypes: EventTypeOption[] }): OptionsDocument {
  const { options, eventTypes } = args
  return eventTypes.reduce((acc, eventType) => deleteEventType({ options: acc, eventType }), options)
}
